import { Node } from "@antv/x6"
import { Input, Space } from "antd"
import Title from "antd/lib/typography/Title"
import { useEffect, useState } from "react"
import { InputWithMM } from "./InputWithMM"


interface UnitLayoutProps {
  unit: Node
  disabled?: boolean
  onChange?: () => void
}

export function UnitLayout(props: UnitLayoutProps) {
  const {unit, disabled = false, onChange} = props
  const unitSize = unit.getSize();
  const unitPosition = unit.getPosition();
  const [size, setSize] = useState(unitSize)
  const [position, setPosition] = useState(unitPosition)

  useEffect(() => {
    if (!unit) return;
    const handlePosChange = (val) => {
      setPosition(val.current)
    }
    const handleSizeChange = (val) => {
      setSize(val.current)
    }
    unit.on('change:position', handlePosChange)

    unit.on('change:size', handleSizeChange)
  }, [unit])

  const onSizeChange = (width: number, height: number) => {
    setSize({width, height})
  }

  const onPosChange = (x: number, y: number) => {
    setPosition({x, y})
  }

  const onSizeBlur = () => {
    const newSize = {...size}
    unit.setSize(newSize)
    onChange?.()
  }

  const onPosBlur = () => {
    const newPos = {...position}
    unit.setPosition(newPos)
    onChange?.()
  }

  return <>
    <Title level={5}>Layout</Title>
    <div>
      <Space>Left: <InputWithMM disabled={disabled} onBlur={onPosBlur} onChange={(val) => onPosChange(val, position.y)} value={position.x} />
      </Space>
      <Space className="mt-1">Top: <InputWithMM disabled={disabled} onBlur={onPosBlur} onChange={(val) => onPosChange(position.x, val)} value={position.y} />
      </Space>
      <Space className="mt-1">Width: <InputWithMM disabled={disabled} onBlur={onSizeBlur} onChange={(val) => onSizeChange(val, size.height)} value={size.width} /></Space>
      <Space className="mt-1">Height: <InputWithMM disabled={disabled} onBlur={onSizeBlur} onChange={(val) => onSizeChange(size.width, val)} value={size.height} /></Space>
    </div>
  </>
}